import { request } from '@/common/services/request';
import type {
  AuthConfig,
  AuthTokenResponse,
  WalletChallenge,
} from '@/types/api';

export type { AuthConfig, AuthTokenResponse, WalletChallenge };

/** GET /v1/auth/config */
export const getAuthConfig = (): Promise<AuthConfig> => {
  return request({
    url: '/v1/auth/config',
    method: 'GET',
    skipAuth: true,
  });
};

/** POST /v1/auth/wallet/challenge */
export const walletChallenge = (address: string): Promise<WalletChallenge> => {
  return request({
    url: '/v1/auth/wallet/challenge',
    method: 'POST',
    data: { address },
    skipAuth: true,
  });
};

/** POST /v1/auth/wallet/verify */
export const walletVerify = (payload: {
  address: string;
  nonce: string;
  message: string;
  signature: string;
}): Promise<AuthTokenResponse> => {
  return request({
    url: '/v1/auth/wallet/verify',
    method: 'POST',
    data: payload,
    skipAuth: true,
  });
};

/** POST /v1/auth/refresh — 与请求拦截器共用同一次刷新，不单独打接口 */
export const refreshAuth = async (): Promise<AuthTokenResponse> => {
  const { refreshSession } = await import('@/common/services/request');
  const result = await refreshSession();
  if (!result.ok || !result.accessToken) {
    const error = new Error('refresh failed') as Error & { code?: string };
    error.code = result.reason;
    throw error;
  }
  return {
    accessToken: result.accessToken,
    tokenType: 'Bearer',
    expiresIn: result.expiresIn ?? 0,
    userId: '',
    address: result.address || '',
    roles: [],
  };
};

/** POST /v1/auth/logout — Cookie credentials；成功 204 No Content */
export const logout = (accessToken?: string): Promise<void> => {
  return request({
    url: '/v1/auth/logout',
    method: 'POST',
    data: {},
    skipAuth: true,
    header: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    timeout: 8000,
    showError: false,
  });
};
